define([
    "./tracking/tracking",
    "./trackingMobile/trackingMobile"
], function () {
});